class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.isUpcoming = this.dataset.upcoming === 'true';
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.variantRadios = this.querySelector('variant-radios');
    this.productBody = this.closest('product-body');
    this.productImage = this.productBody.querySelector('product-image img');
    this.defaultProductImageSrc = this.productImage.src;
    this.purchaseLimitMessage = this.form.querySelector('#ProductFormPurchaseLimitMessage');

    if (this.variantRadios) {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map(fieldset => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });

      this.variantRadios.addEventListener('change', this.onVariantChange.bind(this));
    }

    this.variantInput = this.querySelector('input[name="id"]');
    this.price = this.querySelector('price');
    this.variantTitle = this.querySelector('variant-title');
    this.addButton = this.querySelector('[name="add"]');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updateVariantInput();
    this.updateImage();
    this.updatePrice();
    this.updateVariantTitle();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  createAddButton() {
    const addToCartButton = document.createElement('button');
    addToCartButton.type = 'submit';
    addToCartButton.name = 'add';
    addToCartButton.className = 'typography-button typography-primary product-form__button';

    const buttonLabel = document.createElement('span');
    buttonLabel.className = 'product-form__button-label';
    buttonLabel.textContent = window.variantStrings.addToCart;
    addToCartButton.appendChild(buttonLabel);

    const loadingElement = document.createElement('span');
    loadingElement.className = 'product-form__button-loading rotating';
    const loadingSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    loadingSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    loadingSvg.setAttribute('class', 'icon');
    loadingSvg.setAttribute('fill', 'currentColor');
    loadingSvg.setAttribute('viewBox', '0 0 28 28');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M14 5a8.938 8.938 0 0 1 6.344 2.641l1.86-1.86.796 5.506-5.578-.724 1.867-1.867A7.46 7.46 0 0 0 14 6.5c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5c2.904 0 5.422-1.662 6.668-4.082l1.287.784A8.994 8.994 0 0 1 14 23a9 9 0 0 1 0-18Z');
    loadingSvg.appendChild(path);
    loadingElement.appendChild(loadingSvg);
    addToCartButton.appendChild(loadingElement);
    return addToCartButton;
  }

  enableAddButton() {
    if (this.isUpcoming) return;
    this.addButton.removeAttribute('disabled');
    const addButtonLabel = this.addButton.querySelector('.product-form__button-label');
    addButtonLabel.textContent = window.variantStrings.addToCart;
  }

  toggleAddButton() {
    if (this.isUpcoming) {
      if (this.addButton) {
        this.addButton.setAttribute('disabled', 'disabled');
        this.addButton.querySelector('.product-form__button-label').textContent = 'UPCOMING';
      }
      return;
    }
    if (!this.currentVariant.available) {
      this.purchaseLimitMessage.classList.add('visually-hidden');

      if (!this.addButton) {
        this.addButton = this.createAddButton();
        this.form.appendChild(this.addButton);
      }

      this.addButton.setAttribute('disabled', true);
      const addButtonLabel = this.addButton.querySelector('.product-form__button-label');
      addButtonLabel.textContent = window.variantStrings.soldOut;
      return;
    }

    // Check purchase limit
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        if (!data.items.length) {
          return this.enableAddButton();
        };

        const quantityLimit = parseInt(this.dataset.quantityLimit);
        const cartItem = data.items.filter(item => item.variant_id === this.currentVariant.id)[0];

        // If not reached limit yet
        if (!cartItem || cartItem.quantity < quantityLimit) {
          this.purchaseLimitMessage.classList.add('visually-hidden');

          if (!this.addButton) {
            this.addButton = this.createAddButton();
            this.form.appendChild(this.addButton);
            return;
          }

          return this.enableAddButton();
        }

        // If it's reached to the purchase limit already
        if (cartItem.quantity >= quantityLimit) {
          this.purchaseLimitMessage.classList.remove('visually-hidden');

          if (!this.addButton) return;

          this.form.removeChild(this.addButton);
          this.addButton = null;
        }
      })
      .catch(err => console.log(err));
  }

  updateVariantInput() {
    this.variantInput.value = this.currentVariant.id;
  }

  updateImage() {
    if (!this.currentVariant.featured_image) {
      return this.productImage.srcset = this.defaultProductImageSrc;
    }

    this.productImage.srcset = this.currentVariant.featured_image.src;
  }

  updatePrice() {
    if (this.isUpcoming && this.currentVariant.price === 0) {
      this.price.textContent = 'PRICE TBA';
      return;
    }
    if (!this.currentVariant.available && !this.isUpcoming) {
      this.price.textContent = window.variantStrings.soldOut;
      return;
    }

    const formattedPrice = Shopify.formatMoney(this.currentVariant.price);
    this.price.textContent = formattedPrice;
  }

  updateVariantTitle() {
    if (!this.variantTitle) return;

    const splittedVariantTitle = this.currentVariant.title.split(' | ');
    const variantTitle = `${splittedVariantTitle[0]} | ${splittedVariantTitle[1]}`;
    this.variantTitle.textContent = variantTitle;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (this.isUpcoming) return;

    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });

    fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body,
    })
      .then(response => response.json())
      .then(() => {
        window.location.href = Shopify.locale === 'ja' ? '/cart' : `/${Shopify.locale}/cart`;
      })
      .catch(console.log)
      .finally(() => {
        setTimeout(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        }, 3000);
      });
  }
};

customElements.define('product-form', ProductForm);
